import {message, Radio} from 'antd';
import moment from "moment";
import config from "../configs/config"
import jstz  from 'jstz'
export default class Tools {
    constructor() {

    }

    /**
     * fetch
     * @param:url,method,resolve(callBack of success),body,
     * @desc lockClicked 防止多次点击
     */
    static fetch() {
        let that = this;
        let argument = arguments;
        setTimeout(() => {
            argument = Array.apply([], argument);
            const callBack = argument.filter((item) => (item instanceof Function));
            const parameters = argument.filter((item) => (!(item instanceof Function)));
            if (!argument[0] || !argument[1] || !argument[2]) {
                if (callBack[2]) {
                    callBack[2]('Cannot parse undefined or null');
                }

                throw new TypeError('Cannot parse undefined or null');
            }
            let options = {
                method: argument[1],
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json; charset=utf-8"
                },
                credentials: 'include',
            };
            if ((parameters[1] === 'POST' || parameters[1] === 'PUT' || parameters[1] === 'DELETE') && parameters[2]) {
                options.body = JSON.stringify(parameters[2])
            }
            let url = parameters[0].trim();
            if (url.indexOf('/') !== 0) {
                url = "/" + url;
            }
            fetch(that.getNoCacheURL(url), options, 3000).then((response) => {
                if (response.status === 401) {
                    this.toLoginPageForSessionExpired(response);
                    this.logout(true);
                } else if (response.status === 504) {
                    message.error(Strings.rs10655);
                } else {
                    return response.json();
                }
            }).then((data) => {
                if (data.code === 401) {
                    this.toLoginPageForSessionExpired(response);
                    this.logout(true);
                } else {
                    callBack[0](data);
                }
            }).catch((error) => {
                if (callBack[2]) {
                    callBack[2](error)
                }

            });
        }, 0);
    }

    /**
     * 组装URL,url增加时间戳，语言
     * */
    static getNoCacheURL(url) {
        /**
         * 字符串拼接
         * @constructor
         */
        function StringBuilder(str) {
            this.data = new Array(str);
        }

        StringBuilder.prototype.append = function () {
            this.data.push(arguments[0]);
            return this;
        };
        StringBuilder.prototype.toString = function () {
            return this.data.join('');
        };
        let newURL = new StringBuilder(url);
        if (url.indexOf("?") > -1) {
            newURL.append("&v=").append(moment().unix());
        } else {
            newURL.append("?v=").append(moment().unix());
        }
        const language = localStorage.getItem('language') ? localStorage.getItem('language') : 'zh';
        // console.log(language)
        if (!this.isNull(language)) {
            newURL.append(`&lang=${language}`)
        }
        newURL.append("&source=25");//todo source值待定
        if (url.indexOf('/') !== 0) {
            newURL = `/${newURL}`;
        }

        return encodeURI(newURL.toString());
    }
    static getNoCacheExportURL(url) {
        var newURL = new StringBuilder(url);
        if (url.indexOf("?") > -1) {
            newURL.append("&lang=" + window.language);
        } else {
            newURL.append("?lang=" + window.language);
        }
        if(localStorage.getItem('expType')!=''){
            newURL.append('&expType='+localStorage.getItem('expType'));
        }
        newURL.append("&source=25");
        return encodeURI(newURL.toString());
    }
    /**
     * session过期跳转
     */
    static toLoginPageForSessionExpired(response) {
        var chgPwd = response.headers.get('reason');
        // console.log(response.headers.get('reason')) // CHANGE_PASSWORD
        if (chgPwd && chgPwd == "CHANGE_PASSWORD") {
            this.logout(false);
        } else {
            this.logout(true);
        }

    }

    /**
     * 登出
     */
    static logout(isNormal) {
        let path = this.getApiUrl("logout");
        this.delCookie('USER_TOKEN');
        this.delCookie('username');
        this.delCookie('BMAP_SECKEY');
        localStorage.removeItem("setTabActiveKey");
        localStorage.removeItem("chosedTabs");
        window.location.href = "/"
    }

    /**
     * 删除cookie
     * @param name
     */
    static delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';path=/';//避免跨越iframe无法删除cookie
    }

    /**
     * 设置cookie
     * @param name
     * @param value
     */
    static setCookie(name, value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
    }

    /**
     * 获取cookie
     * @param name
     * @returns {*}
     */
    static getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }

    /**
     * isNull
     * 作用：判断是否为空
     * @param:str:String || float
     */
    static isNull(str) {
        return (str === null || str === undefined || String(str).replace(/\s+/g, '') === '');
    }

    /**
     * 日历转化为秒组装
     * @param value
     * @returns {{start: number, end: number}|null}
     */
    static getTimeFromCalendar(value) {
        return value ? {
            start: moment(value[0]).startOf("day").unix(),
            end: moment(value[1]).endOf("day").unix()
        } : null;
    }

    //获取区域
    static getZoneName() {
        const timezone = jstz.determine();
        if (timezone && timezone.name) {
            return timezone.name();
        }
        return ""
    }

    /**
     * moment返回YYYY-MM-DD HH:mm:ss 传入时间戳格式为秒
     * @param time
     * @returns {string|string}
     */
    static formatTimeYMDHms(time) {
        if (time && time.toString().length === 10) {
            time = time * 1000;
        }
        return time ? moment(time).format("YYYY-MM-DD HH:mm:ss") : "";
    }

    //获取URL
    static getApiUrl(key, platform) {
        let plat = platform || "iop"
        let temp_config = config[platform]
        return temp_config.restApis[key];
    }

    /**
     * removeSpace
     * 作用：去除字符串的所有空格
     * @param str : String
     * @return str : String
     */
    static removeSpace(str) {
        if (typeof str !== 'string') {
            throw new Error('Use a string as a param')
        } else {
            return str.replace(/\s+/g, '');
        }
    }

    /**
     * testPassword
     * 作用：验证密码是否符合规范
     * @param str : String
     * @return boolean
     */
    static testPassword(str) {
        return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(str)
    }

    /**
     * 判断是否 是 监控角色--8
     */
    static isMonitor() {
        var accountType = localStorage.getItem("accountType");
        return accountType == 8;
    }

    /**
     * 是否是任务导出的方式
     * @param platform
     * @returns {boolean|*}
     */
    static isExportWithTask(platform){
        let temp_config = config[platform];
        return temp_config.exportTask;
    }

    /**
     * 是否是设备管理维度
     */
    static isDeviceMgt(platform){
        let temp_config = config[platform];
        return temp_config.isDeviceMgt;
    }
    /**
     * 获取列表展示的keyCode
     */
    static getKeyCode(platform){
        let temp_config = config[platform];
        return temp_config.listKey;
    }
    /**
     * 项目是否有全局字典
     * @param platform
     * @returns {boolean|*}
     */
    static isHasWholeEnum(platform){
        let temp_config = config[platform];
        return temp_config.hasEnum;
    }
    /**
     * 据全局枚举定义生成对应key的下拉框选项,radio,checkbox
     * @param key
     * @param type
     * @returns {*|null}
     */
    static getOptionsFromGlobalEnums(key,type){
        let globalEnums = JSON.parse(localStorage.getItem("globalEnums"));
        if(globalEnums && globalEnums[key]){
            if(type === "select"){//下拉框
                return globalEnums[key].map((item)=>{
                    return <Option key={item.code} value={item.code}>{item.name}</Option>
                })
            }else if(type === "radio"){
                return globalEnums[key].map((item)=>{
                    return <Radio key={item.code} value={item.code} title={item.name}>
                        {item.value ?<img src={item.value} title={item.name}></img>:null}
                    </Radio>
                })
            }else if(type === "checkbox"){
                /*  return globalEnums[key].map((item)=>{
                      return <Option key={item.code} value={item.code}>{item.name}</Option>
                  })*/
            }else{
                return globalEnums[key]
            }

        }else{
            return null;
        }
    }
    /**
     * isNumber
     * 作用：判断字符串是否只含数字
     * @param str : string
     * @return boolean
     */
    static isNumber(str) {
        return /^[0-9]+$/.test(str);
    }
    // 只能输入数字
    static getnum(num) {
        // var num = 22.123456;
        var aNew;
        var re = /([0-9]+\.[0-9]{2})[0-9]*/;
        var isHasDigit = num.toString().indexOf('.') >= 0;
        if (isHasDigit) {
            var numArr = num.toString().split('.');
            if (numArr[1].length > 2) {
                aNew = num.toString().replace(re, "$1");
            } else {
                aNew = num
            }
        } else {
            aNew = num
        }
        console.log(aNew);
        return aNew;
    }
    /**
     * 禁止选择的日期
     * @param time : any
     * @return boolean
     */
    static handleDisabledBeforeDate(time){
        if (!time) {
            return false;
        } else {
            return (moment().valueOf() > (time.valueOf()+86399999));
        }
    }
    /**
     *
     * 作用：复制固定文本到粘贴板
     *
     */
    static copy (text) {
        // text是复制文本
        // 创建input元素
        const el = document.createElement('input')
        // 给input元素赋值需要复制的文本
        el.setAttribute('value', text)
        // 将input元素插入页面
        document.body.appendChild(el)
        // 选中input元素的文本
        el.select()
        // 复制内容到剪贴板
        document.execCommand('copy')
        // 删除input元素
        document.body.removeChild(el)
        message.success(Strings.rs10733 || Strings.copy)
    }
    /**
     * 据全局枚举定义生成对应key的下拉框选项,radio,checkbox
     * @param key
     * @param type
     * @returns {*|null}
     */
    static getOptionsFromGlobalEnums(key,type){
        let globalEnums = JSON.parse(localStorage.getItem("globalEnums"));
        if(globalEnums && globalEnums[key]){
            if(type === "select"){//下拉框
                return globalEnums[key].map((item)=>{
                    return <Option key={item.code} value={item.code}>{item.name}</Option>
                })
            }else if(type === "radio"){
                return globalEnums[key].map((item)=>{
                    return <Radio key={item.code} value={item.code} title={item.name}>
                        {item.value ?<img src={item.value} title={item.name}></img>:null}
                    </Radio>
                })
            }else if(type === "checkbox"){
                /*  return globalEnums[key].map((item)=>{
                      return <Option key={item.code} value={item.code}>{item.name}</Option>
                  })*/
            }else{
                return globalEnums[key]
            }

        }else{
            return null;
        }
    }
    /**
     * 据全局枚举定义生成对应key的文本值
     * @param key
     * @param type
     * @param value
     * @returns {*|null}
     */
    static getLabelFromGlobalEnums(key,type,value){
        let arr_key = this.getOptionsFromGlobalEnums(key,type);
        if(arr_key.length && !this.isNull(value)){
            let filterd_obj = arr_key.filter((item)=>item.code === value.toString())[0];
            return filterd_obj?filterd_obj.name:"";
        }else{
            return ""
        }
    }
}